import { BASE_PATH_CMS } from '../constants'

export const getBaseUrl = (lng: string) => {
  if (lng === 'en') {
    return `${BASE_PATH_CMS}/en`
  }

  return BASE_PATH_CMS
}
